import React, {Component} from "react";
import {Grid, Row, Col, FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import Card from "../../components/Card/Card.jsx";
import Switch from "react-bootstrap-switch";
import axios from "axios/index";
import { css } from "@emotion/core";
import {ScaleLoader} from 'react-spinners';
import {Redirect} from "react-router";
import Button from "../../components/CustomButton/CustomButton";
import ImageUpload from "../../components/ImageUpload/ImageUpload";
import ModalSave from "../../components/CustomModals/ModalSave";
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import NotificationSystem from "react-notification-system";
import {style} from "../../variables/Variables";

const override = css`
    position: fixed;
    left: 50%;
    top: 35%;
    display: block;
    z-index: 1000;
    height: 31px;
    width: 100px;
    `;

class EditRadioCategory extends Component {

    constructor(props) {
        super(props);
        this.state = {

            _notificationSystem: null,

            loading: false,
            saving: false,
            redirect: false,
            radioCatRedirect: false,
            back_button_text: "Cancel",
            showSaveModal: false,

            radioCategoryObject: [],

            radio_cat_id: 0,
            radio_cat_position: 0,
            radio_cat_status: false,
            radio_cat_image: "",
            radio_cat_name_short: "",
            radio_cat_name_long: "",
            radio_cat_description: "",
            radio_cat_date_added: "",
            radio_cat_user_added: 1,
            radio_cat_date_updated: "",
            radio_cat_user_updated: "",
            radio_cat_date_deleted: "",
            radio_cat_user_deleted: "",

            radio_cat_image_temp: false,
            radio_cat_image_folder_temp: ""
        };

        // this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleChildImageSelect = this.handleChildImageSelect.bind(this);

    }

    setRedirect = () => {
        this.setState({
            redirect: true
        })
    }

    renderRedirect = () => {

        let path = "/categories/radio";
        let pathCategory = "/categories/edit-radio-cat/" + this.state.radio_cat_id;

        if (this.state.redirect) {
            return <Redirect push to={path}/>
        }

        if (this.state.radioCatRedirect) {
            console.log(pathCategory);
            return <Redirect push to={pathCategory}/>
        }

    }


    submitCatImage(filename) {

        if (this.state.radio_cat_image_temp) {
            const url = process.env.REACT_APP_IMAGE_SUBMIT_API_URL;

            let bodyFormData = new FormData();
            bodyFormData.set('filepond[]', this.state.radio_cat_image_folder_temp);
            bodyFormData.set('location', "live_radio_cat");
            bodyFormData.set('filename', filename);

            axios.post(url, bodyFormData)
                .then((res) => {
                    console.log("RESPONSE RECEIVED: ", res);
                    this.setState({radio_cat_image_temp: false})
                })
                .catch((err) => {
                    console.log("AXIOS ERROR: ", err);
                })
        }

    }

    handleChildImageSelect(folder, filename) {

        console.log("" + folder);
        console.log("" + filename);
        console.log(process.env.REACT_APP_ASSET_URL + "/tmp/" + folder + "/" + filename);

        this.setState({
            radio_cat_image_temp: filename !== null,
            radio_cat_image: filename,
            radio_cat_image_folder_temp: folder
        });
    }

    componentDidMount() {

        this.setState({_notificationSystem: this.refs.notificationSystem})
        this.setState({saving: false, loading: true})

        const {handle} = this.props.match.params
        const url = process.env.REACT_APP_API_URL + "/RadioCategory/" + handle;

        if (handle === 'new') {
            this.setState({loading: false})
        } else {

            let user = JSON.parse(localStorage.getItem('user'));
            let token = ""

            if (user) {
                token = user.token
            } else {
                this.props.dispatch(userActions.logoutUnauthorized());
            }

            let axiosConfig = {
                headers: {
                    'X-Id-Token': token
                }
            };

            axios
                .get(url, axiosConfig)
                .then(res => {

                    const categoryObject = res.data[0];
                    const loading = false;

                    console.log(categoryObject);

                    this.setState({
                        back_button_text: "Back",
                        radio_cat_id: categoryObject.radio_cat_id,
                        radio_cat_status: categoryObject.radio_cat_status === 0 ? false : true,
                        radio_cat_position: categoryObject.radio_cat_position === null ? 0 : categoryObject.radio_cat_position,
                        radio_cat_name_short: categoryObject.radio_cat_name_short === null ? "" : categoryObject.radio_cat_name_short,
                        radio_cat_name_long: categoryObject.radio_cat_name_long === null ? "" : categoryObject.radio_cat_name_long,
                        radio_cat_description: categoryObject.radio_cat_description === null ? "" : categoryObject.radio_cat_description,
                        radio_cat_image: categoryObject.radio_cat_image === null ? "" : categoryObject.radio_cat_image,
                        loading,
                        radioCategoryObject: categoryObject
                    });
                })
                .catch((err) => {
                    console.log("ERROR: ", err);
                    this.setState({saving: false, loading: false})
                    //this.props.dispatch(userActions.logoutUnauthorized());
                })
        }
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'statusSwitch' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    updateRadioCategory() {

        this.setState({saving: false, loading: true})

        const {handle} = this.props.match.params
        const url = process.env.REACT_APP_API_URL + "/RadioCategory/" + handle;

        let tempRadioStatus = this.state.radio_cat_status === true ? 1 : 0;

        let filename = ""

        if (this.state.radio_cat_image_temp) {
            let timeUTC = new Date().getTime()
            filename = timeUTC + "_" + this.state.radio_cat_image
            this.setState({radio_cat_image: filename})
            //console.log("*****" + filename)
            this.submitCatImage(filename);
        } else {
            filename = this.state.radio_cat_image
        }

        // Send a PUT request
        var postData = {
            radio_category: {
                radio_cat_id: handle,
                radio_cat_status: tempRadioStatus,
                radio_cat_position: this.state.radio_cat_position,
                radio_cat_name_short: this.state.radio_cat_name_short,
                radio_cat_name_long: this.state.radio_cat_name_long,
                radio_cat_description: this.state.radio_cat_description,
                radio_cat_image: filename
            }
        };

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token,
                'Content-Type': 'application/json'
            }
        };

        axios.put(url, postData, axiosConfig)
            .then((res) => {
                console.log("RESPONSE RECEIVED: ", res);
                this.notification("success")
                this.setState({saving: false, loading: false})

            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
                this.notification("failed")
                //this.props.dispatch(userActions.logoutUnauthorized());
                this.setState({saving: false, loading: false})
            })

    }

    createRadioCategory() {

        this.setState({saving: false, loading: true})

        const url = process.env.REACT_APP_API_URL + "/RadioCategory";

        let tempRadioStatus = this.state.radio_cat_status === true ? 1 : 0;

        let filename = ""

        if (this.state.radio_cat_image_temp) {
            let timeUTC = new Date().getTime()
            filename = timeUTC + "_" + this.state.radio_cat_image
            this.setState({radio_cat_image: filename})
            //console.log("*****" + filename)
            //this.submitCatImage(filename);
        } else {
            filename = this.state.radio_cat_image
        }

        var postData = {
            radio_category: {
                radio_cat_status: tempRadioStatus,
                radio_cat_position: this.state.radio_cat_position,
                radio_cat_name_short: this.state.radio_cat_name_short,
                radio_cat_name_long: this.state.radio_cat_name_long,
                radio_cat_description: this.state.radio_cat_description,
                radio_cat_image: filename
            }
        };

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if (user) {
            token = user.token
        } else {
            this.props.dispatch(userActions.logoutUnauthorized());
        }

        let axiosConfig = {
            headers: {
                'X-Id-Token': token,
                'Content-Type': 'application/json'
            }
        };

        axios.post(url, postData, axiosConfig)
            .then((res) => {
                console.log("RESPONSE RECEIVED: ", res);
                this.setState({saving: false, loading: false})
                //this.submitPosterImage();
                this.submitCatImage(filename);

                if (res.data.code === 300) {
                    console.log("*1: ", res.data.code);
                    console.log("*2: ", res.data.message);
                    //this.handleValidationError(res.data)
                }
                const radioCategoryObject = res.data;
                this.setState({radio_cat_id: radioCategoryObject.radio_cat_id})
                console.log("radio_cat_id SAVED: " + radioCategoryObject.radio_cat_id);
                this.notification("success")
                this.setRadioCatRedirect();

            })
            .catch((err) => {
                console.log("AXIOS ERROR: ", err);
                this.notification("failed")
                this.setState({saving: false, loading: false})
                //this.props.dispatch(userActions.logoutUnauthorized());
            })

    }

    handleSwitch(elem, state) {
        if (elem.props.name === 'statusSwitch') {
            this.setState({radio_cat_status: state})
        }
    }

    cancelRadioCatEdit() {
        this.setRedirect();
    }

    setRadioCatRedirect = () => {
        this.setState({
            radioCatRedirect: true,
            back_button_text: "Back"
        })
    }

    setSaveModal = (value, action) => {

        this.setState({
            showSaveModal: value

        })

        if (action === "save") {
            this.setState({saving: true})

            const {handle} = this.props.match.params

            if (handle === 'new') {
                this.createRadioCategory();
            } else {
                this.updateRadioCategory();
            }
        }
    }

    renderSaveModal = () => {

        if (this.state.showSaveModal) {
            return <ModalSave
                headerMessage={"Radio Category: "}
                bodyMessage={"this action will save all changes, click close to cancel saving"}
                handlerFromParent={this.setSaveModal}
                handlerID={this.state.radio_cat_id === 0 ? '' : this.state.radio_cat_id}
            />
        }
    }

    notification(status) {

        if (status === "success") {
            this.state._notificationSystem.addNotification({
                title: (<span data-notify="icon" className="fa fa-check"></span>),
                message: (
                    <div>
                        <b>Category has been updated</b>
                    </div>
                ),
                level: 'success',
                position: 'tr',
                autoDismiss: 5,
            });
        }

        if (status === "failed") {
            this.state._notificationSystem.addNotification({
                title: (<span data-notify="icon" className="fa fa-check"></span>),
                message: (
                    <div>
                        <b>failed to update category</b>
                    </div>
                ),
                level: 'error',
                position: 'tr',
                autoDismiss: 10,
            });
        }

    }

    title() {
        if (this.state.radio_cat_name_short === null) {
            return "New - " + this.props.t('radio_category_edit.main_title', {framework: "react-i18next"});
        } else {
            return this.state.radio_cat_name_short + " - " + this.props.t('radio_category_edit.main_title', {framework: "react-i18next"});
        }
    }

    render() {
        return (
            <div className="main-content">

                <NotificationSystem ref="notificationSystem" style={style}/>
                {this.renderRedirect()}
                {this.renderSaveModal()}

                <div className="sweet-loader">
                    <ScaleLoader
                        css={override}
                        color={'#797979'}
                        loading={this.state.loading}
                    />
                </div>


                <Grid fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={6}>
                            <Card
                                title={this.title()}
                                content={
                                    <div>
                                        <legend></legend>
                                        <FormGroup>
                                            <ImageUpload
                                                imageName={this.state.radio_cat_image}
                                                imageType="live_radio_cat"
                                                imagePosition={"radio_cat_image"}
                                                imageTemp={this.state.radio_cat_image_temp}
                                                imageFolderTemp={this.state.radio_cat_image_folder_temp}
                                                handlerFromParent={this.handleChildImageSelect}
                                            />
                                        </FormGroup>
                                        <legend></legend>

                                        <FormGroup>
                                            <p className="category">{this.props.t('global.status', {framework: "react-i18next"})}</p>
                                            <Switch
                                                name={"statusSwitch"}
                                                disabled={this.state.loading}
                                                value={this.state.radio_cat_status}
                                                onChange={(el, state) => this.handleSwitch(el, state)}
                                            />
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>{this.props.t('global.position', {framework: "react-i18next"})}</ControlLabel>
                                            <FormControl
                                                placeholder={this.props.t('radio_category_edit.position_placeholder', {framework: "react-i18next"})}
                                                type="number"
                                                name={"radio_cat_position"}
                                                disabled={this.state.loading}
                                                onChange={this.handleInputChange}
                                                value={this.state.radio_cat_position}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>{this.props.t('radio_category_edit.name_short', {framework: "react-i18next"})}</ControlLabel>
                                            <FormControl
                                                placeholder={this.props.t('radio_category_edit.name_short_placeholder', {framework: "react-i18next"})}
                                                type="text"
                                                name={"radio_cat_name_short"}
                                                disabled={this.state.loading}
                                                onChange={this.handleInputChange}
                                                value={this.state.radio_cat_name_short}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>{this.props.t('radio_category_edit.name_long', {framework: "react-i18next"})}</ControlLabel>
                                            <FormControl
                                                placeholder={this.props.t('radio_category_edit.name_long_placeholder', {framework: "react-i18next"})}
                                                type="text"
                                                name={"radio_cat_name_long"}
                                                disabled={this.state.loading}
                                                onChange={this.handleInputChange}
                                                value={this.state.radio_cat_name_long}/>
                                        </FormGroup>

                                        <FormGroup>
                                            <ControlLabel>{this.props.t('radio_category_edit.description', {framework: "react-i18next"})}</ControlLabel>
                                            <FormControl componentClass="textarea"
                                                         type="text"
                                                         name="radio_cat_description"
                                                         disabled={this.state.loading}
                                                         onChange={this.handleInputChange}
                                                         placeholder={this.props.t('radio_category_edit.description_placeholder', {framework: "react-i18next"})}
                                                         value={this.state.radio_cat_description}
                                            />
                                        </FormGroup>


                                    </div>
                                }
                                ftTextCenter
                                legend={
                                    <div className="buttons-with-margin">
                                        <Button bsStyle="info" fill wd
                                                name={"saveButton"}
                                                disabled={this.state.loading}
                                                onClick={() => this.setState({showSaveModal: true})}
                                        >
                                            {this.state.loading ? 'Loading...' : this.props.t('global.save', {framework: "react-i18next"})}
                                        </Button>
                                        <Button bsStyle="default" fill wd
                                                name={"cancelButton"}
                                                disabled={this.state.loading}
                                                onClick={this.cancelRadioCatEdit.bind(this)}>
                                            {this.state.back_button_text}
                                        </Button>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedEditRadioCategory = connect(mapStateToProps)(EditRadioCategory);
const connectedEditRadioCategoryTrans = withNamespaces('common')(connectedEditRadioCategory);
export {connectedEditRadioCategoryTrans as EditRadioCategory};
